module.exports = __webpack_public_path__ + "background-image.e725b7524ae8f049811a.jpg";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/background-image.jpg
// module id = ../../../../../src/img/background-image.jpg
// module chunks = styles